import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { genURL } from '../_getjson';
import axios from 'axios'
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import Backdrop from './../Components/CustomBackdrop/Barckdrop'
require('../_css/PopUpOther.css');
export default class PopUpOther extends React.Component {
    constructor(props) {
        super(props);
        this.CustomerName = React.createRef();
        this.state = {
            type: this.props.type,
            col: [],
            rows: [],
            valueRetuen: "",
            SHtype: 3,
            showSH: '',
            textSearch: "",
            selected: "0",
            type: "",
            openBackdrop: false,
            autoClose: 3600,
            color: "warning",
            messagealert: ""
        }
    }
    componentDidMount() {
        this._loadData("");
    }
    onKeyUp = (e) => {
        if (e.key === 'Enter') {
            var txt = e.target.value;
            this._loadData(txt);
        }
    }
    _loadData = (value) => {
        var by = this.state.selected
        var url
        if (this.props.type === "Issuetype") {
            this.setState({ openBackdrop: true })
            url = "CSISSUETYPE/";
            let Codewt = "GETCODES?Codes=";
            let Namewt = "GETNAME?Name=";
            let Allwt = "GETALL?";
            if (value !== "" && by === "1") {
                url += Namewt + value;
            }
            if (value !== "" && by === "0") {
                url += Codewt + value;
            }
            if (value === "") {
                url += Allwt;
            }
            var arrdata = [];
            console.log(genURL(url));
            axios.get(genURL(url), { timeout: 3600 }).then(res => {
                var data = res.data
                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++) {
                        arrdata[i] = {
                            number: i + 1,
                            code: data[i].CODE,
                            text: data[i].MYNAMETH,
                        }
                    }
                } else {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ไม่พบข้อมูล!" })
                }
                this.setState({ rows: arrdata });
                this.setState({ openBackdrop: false })
            }).catch(error => {
                console.log(error);
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่สามารถเชื่อมต่อฐานข้อมูลได้!" })
                this.setState({ openBackdrop: false })
            });
        }
    }
    onSelectRow = (data) => {
        this.setState({ valueRetuen: (data.code) + "|" + (data.text) });
        let reData = (data.code) + "|" + (data.text);
        setTimeout(() => {
            this.props.Get_PopUpOther(reData);
            this.props.closePopup();
        }, 100);
    }
    render() {
        return (
            <div className='popup'>
                <Backdrop open={this.state.openBackdrop} />
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > ประเภทการเบิก </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="DivTable">
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === '0'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === '1'} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop">
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" onKeyUp={this.onKeyUp} ref={this.CustomerName} />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={() => { this._loadData(this.CustomerName.current.value) }}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>
                        <BootstrapTable
                            data={this.state.rows}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูลที่ค้นหา",
                            }}
                            height="750"
                            hover condensed >
                            <TableHeaderColumn columnClassName="columnAll? columnID" className="columnNumber" dataAlign="center" width="40" dataField='number' isKey> </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="40%" dataField='code' > รหัส </TableHeaderColumn>
                            <TableHeaderColumn columnClassName="columnAll?" className="columnNumber" width="50%" dataField='text'  > ชื่อ/คำอธิบาย </TableHeaderColumn>
                        </BootstrapTable>
                        <p align="center"><i id="load"></i></p>
                    </div>
                </div>
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div>
        );
    }
}